module.exports = __webpack_public_path__ + "img/banner.19660835.png";